class SizeChartModal extends HTMLElement {
  constructor() {
    super()
    this.modal = document.querySelector('.SizeChartModal')
    this.closeButton = this.modal.querySelector('.SizeChartModal__close')
    this.overlay = this.modal.querySelector('.SizeChartModal__overlay')
    this.modalBody = this.modal.querySelector('.SizeChartModal__body')
    this.findSizeButton = this.querySelector('.js-open-size-chart-modal')
    this.lastFocusedElement = null
    this.isModalOpen = false
    this.handleOpenModal = this.handleOpenModal.bind(this)
    this.handleCloseModal = this.handleCloseModal.bind(this)
    this.handleKeyDown = this.handleKeyDown.bind(this)
    this.handleButtonKeyDown = this.handleButtonKeyDown.bind(this)
  }

  connectedCallback() {
    if (this.findSizeButton) {
      this.findSizeButton.addEventListener('click', this.handleOpenModal)
      this.findSizeButton.addEventListener('keydown', this.handleButtonKeyDown)
    }
    this.closeButton.addEventListener('click', this.handleCloseModal)
    this.overlay.addEventListener('click', this.handleCloseModal)
  }

  disconnectedCallback() {
    if (this.findSizeButton) {
      this.findSizeButton.removeEventListener('click', this.handleOpenModal)
      this.findSizeButton.removeEventListener('keydown', this.handleButtonKeyDown)
    }
    this.closeButton.removeEventListener('click', this.handleCloseModal)
    this.overlay.removeEventListener('click', this.handleCloseModal)
    document.removeEventListener('keydown', this.handleKeyDown)
  }

  async handleOpenModal() {
    if (!this.modal || this.isModalOpen) {
      return
    }

    this.isModalOpen = true
    this.lastFocusedElement = document.activeElement

    try {
      this.modalBody.innerHTML = '<p>Loading...</p>'
      const response = await fetch('/pages/size-chart')
      if (!response.ok) throw new Error('Failed to load size chart')

      const html = await response.text()
      const mainElement = new DOMParser().parseFromString(html, 'text/html').querySelector('#MainContent')
      this.modalBody.innerHTML = mainElement.innerHTML
    } catch (error) {
      console.error('Error loading size chart:', error)
      this.modalBody.innerHTML = '<p>Error loading size chart. Please try again later.</p>'
    }

    this.modal.classList.remove('hidden')
    document.body.style.overflow = 'hidden'
    document.addEventListener('keydown', this.handleKeyDown)

    const focusableElements = this.modal.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])')
    if (focusableElements.length > 0) {
      focusableElements[0].focus()
    }
  }

  handleCloseModal() {
    if (!this.modal || this.modal.classList.contains('hidden')) {
      return
    }

    this.modal.classList.add('hidden')
    document.body.style.overflow = ''
    document.removeEventListener('keydown', this.handleKeyDown)
    this.isModalOpen = false

    if (this.lastFocusedElement) {
      this.lastFocusedElement.focus()
    }
  }

  handleKeyDown(event) {
    if (event.key === 'Escape') {
      this.handleCloseModal()
    } else if (event.key === 'Tab') {
      const focusableElements = this.modal.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])')
      const firstElement = focusableElements[0]
      const lastElement = focusableElements[focusableElements.length - 1]

      if (event.shiftKey) {
        if (document.activeElement === firstElement) {
          event.preventDefault()
          lastElement.focus()
        }
      } else {
        if (document.activeElement === lastElement) {
          event.preventDefault()
          firstElement.focus()
        }
      }
    }
  }

  handleButtonKeyDown(event) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault()
      this.handleOpenModal()
    }
  }
}

customElements.define('size-chart-modal', SizeChartModal)
